import React from 'react';
import { useTranslation } from 'react-i18next';

export function ErrorPermissionBox() {
  const { t } = useTranslation();

  return (
    <div className="ct-permission-error">
      <h1>{t('permission_error')}</h1>
      <p>{t('you_dont_have_the_permission')}</p>
      <a href="/">{t('back')}</a>
      <span>{t('permission_error')}</span>
    </div>
  );
}
